import { HttpClient } from '@angular/common/http';
import { LeaderboardTriviaPort } from '../../../domain/leaderboard/ports/leaderboard-trivia.port';
import { LeaderboardTriviaHttpAdapter } from '../adapters/leaderboard-trivia-http.adapter';
import { LeaderboardTriviaStubAdapter } from '../adapters/leaderboard-trivia-stub.adapter';
import { ENVIRONMENT } from '../../../../environments/environment';

export function leaderboardTriviaPortFactory(http: HttpClient): LeaderboardTriviaPort {
  const useHttp = !ENVIRONMENT.mockEnabled && Boolean(ENVIRONMENT.leaderboardEventsApiUrl?.trim());
  return useHttp ? new LeaderboardTriviaHttpAdapter(http) : new LeaderboardTriviaStubAdapter();
}
